import { HisTypeOptionsType } from './types';

export const HIS_TYPE_OPTIONS: HisTypeOptionsType = [
  { id: 'twink', title: '🍑 Twink' },
  { id: 'daddy', title: '🧔‍♂️ Daddy' },
  { id: 'trans', title: '⚧️ Trans' },
  { id: 'otter', title: '🦦 Otter' },
  { id: 'queer', title: '🌈 Queer' },
  { id: 'leather', title: '🖤 Leather' },
  { id: 'boy', title: '🧢 Boy' },
  { id: 'pup', title: '🐶 Pup' },
  { id: 'clean_cut', title: '✂️ Clean-cut' },
  { id: 'jock_sporty', title: '🏈 Jock / Sporty' },
  { id: 'bear', title: '🐻 Bear' },
  { id: 'geek', title: '🤓 Geek' },
];
